import { getNewsSortTime, sortNewsByPublished } from "./newsSort";

export const getNewsId = (item) => {
  const numericId = Number(item?.id);
  return Number.isFinite(numericId) ? numericId : 0;
};

export const getLatestNewsId = (items) => {
  return items.reduce((latest, item) => Math.max(latest, getNewsId(item)), 0);
};

export const getNewsKey = (item) => {
  const id = getNewsId(item);
  if (id > 0) return `id:${id}`;
  return item?.link ? `link:${item.link}` : "";
};

export const mergeUniqueNewsByPublished = (...groups) => {
  const unique = [];
  const seen = new Set();

  groups.flat().forEach((item) => {
    const key = getNewsKey(item);
    if (!key || seen.has(key)) return;

    seen.add(key);
    unique.push(item);
  });

  return sortNewsByPublished(unique);
};

const getNewsCursorSortDate = (item) => {
  return String(
    item?.sort_date ||
    item?.published_str ||
    ""
  ).trim();
};

const getCursorSortTime = (cursor) => {
  const rawValue = String(
    cursor?.sortDate || ""
  ).trim();

  if (!rawValue) return 0;

  const normalizedValue =
    /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/.test(
      rawValue
    )
      ? `${rawValue.replace(" ", "T")}Z`
      : rawValue;

  const timestamp = new Date(
    normalizedValue
  ).getTime();

  return Number.isFinite(timestamp)
    ? timestamp
    : 0;
};

export const getLatestNewsCursor = (items) => {
  let latestCursor = {
    id: 0,
    sortDate: "",
  };
  let latestSortTime = 0;

  (items || []).forEach((item) => {
    const id = getNewsId(item);
    const sortDate = getNewsCursorSortDate(item);
    const sortTime = getNewsSortTime(item);

    if (
      !id ||
      !sortDate ||
      !sortTime
    ) {
      return;
    }

    if (
      sortTime > latestSortTime ||
      (
        sortTime === latestSortTime &&
        id > latestCursor.id
      )
    ) {
      latestSortTime = sortTime;
      latestCursor = {
        id,
        sortDate,
      };
    }
  });

  return latestCursor;
};

export const isCursorAfter = (next, current) => {
  if (
    !next?.id ||
    !next?.sortDate
  ) {
    return false;
  }

  if (
    !current?.id ||
    !current?.sortDate
  ) {
    return true;
  }

  const nextTime = getCursorSortTime(next);
  const currentTime = getCursorSortTime(current);

  if (nextTime !== currentTime) {
    return nextTime > currentTime;
  }

  return next.id > current.id;
};

export const getOldestNewsCursor = (items) => {
  let oldestItem = null;
  let oldestSortTime = Number.POSITIVE_INFINITY;
  let oldestId = Number.POSITIVE_INFINITY;

  (items || []).forEach((item) => {
    const id = getNewsId(item);
    const sortTime = getNewsSortTime(item);

    if (
      oldestItem === null ||
      sortTime < oldestSortTime ||
      (sortTime === oldestSortTime && id < oldestId)
    ) {
      oldestItem = item;
      oldestSortTime = sortTime;
      oldestId = id;
    }
  });

  return oldestItem
    ? {
        id: getNewsId(oldestItem),
        sortDate: getNewsCursorSortDate(oldestItem),
      }
    : {
        id: 0,
        sortDate: "",
      };
};
